import { Account } from '@/domain/usecases'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import SearchLoader from './search-loader'

export default class DependentCatalogLoader extends SearchLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient, true)
  }
}
